import React from "react";

// The site mark on its own — the emblem the wordmark carries on its left, cropped to
// a square box so it can stand in for the logo where there is no room for lettering
// (the collapsed sidebar rail).
const OnBibleEmblem = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="34"
		height="34"
		viewBox="0 0 34 34"
		fill="none"
		data-testid="onbible-emblem"
	>
		<path
			d="M18.0542 10.0241L17.7917 9.76159H15.8494V12.9638H12.7523V15.1686H15.8494V24.1454H18.0542V15.1686H21.1513V13.1738L20.8889 12.9638H18.0542V10.0241Z"
			fill="url(#paint0_linear_emblem)"
		/>
		<path
			d="M17.7917 12.9638H20.8889V14.9062H17.7917V24.1454H15.8494V14.9062H12.7523V12.9638H15.8494V9.76159H17.7917V12.9638Z"
			fill="url(#paint1_linear_emblem)"
		/>
		<path
			d="M17.7917 12.9638H20.8889V14.9062H17.7917V24.1454H15.8494V14.9062H12.7523V12.9638H15.8494V9.76159H17.7917V12.9638Z"
			fill="url(#paint2_linear_emblem)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M25.4111 8.52506C19.9835 3.09733 11.9264 2.70153 7.39647 7.23158C2.86655 11.7616 3.26234 19.819 8.68991 25.2467C14.1175 30.6745 22.1746 31.0703 26.7046 26.5402C31.2345 22.0102 30.8387 13.9528 25.4111 8.52506ZM5.05222 4.88726C7.89929 2.04011 11.7081 0.744377 15.6217 0.886413C19.8718 1.04066 24.2455 2.89058 27.6455 6.29062C30.9112 9.55644 32.7468 13.7207 33.0234 17.8109C33.2998 21.9002 32.0179 25.9153 29.0488 28.8845C23.1099 34.8237 12.9862 34.0121 6.45554 27.4812C-0.0751389 20.9503 -0.886729 10.8264 5.05222 4.88726Z"
			fill="url(#paint3_linear_emblem)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.31527 16.9686C3.31527 9.42815 9.42787 3.31537 16.9682 3.31537C24.5084 3.31537 30.621 9.42815 30.621 16.9686C30.621 24.5091 24.5084 30.6219 16.9682 30.6219C9.42787 30.6219 3.31527 24.5091 3.31527 16.9686ZM16.9682 0C7.5969 0 0 7.59712 0 16.9686C0 26.3402 7.5969 33.9373 16.9682 33.9373C21.7617 33.9373 26.091 31.9495 29.1767 28.7533C32.1236 25.7009 33.9363 21.5465 33.9363 16.9686C33.9363 12.2963 32.048 8.06508 28.9929 4.99648C32.3629 8.41405 33.686 13.1481 33.0234 17.8109C32.7468 13.7207 30.9112 9.55644 27.6455 6.29062C24.2455 2.89058 19.8718 1.04066 15.6217 0.886413C20.1876 0.121662 24.8613 1.26373 28.3355 4.37041C25.327 1.65396 21.3407 0 16.9682 0Z"
			fill="url(#paint4_linear_emblem)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.6217 0.886413C19.8718 1.04066 24.2455 2.89058 27.6455 6.29062C30.9112 9.55644 32.7468 13.7207 33.0234 17.8109C32.5082 21.4363 30.7926 25.0187 27.9056 27.9059C24.6686 31.1429 20.5578 32.9073 16.4922 33.1582C12.2847 33.418 8.12562 32.0567 5.03391 29.0296C4.79657 28.7948 4.56615 28.553 4.34293 28.3046C-1.10362 22.1776 -0.466102 12.3472 5.94062 5.94032C8.71784 3.16302 12.1384 1.46983 15.6217 0.886413ZM28.9929 4.99648C28.9691 4.97241 28.9453 4.94841 28.9214 4.92448C28.8788 4.88191 28.836 4.83971 28.793 4.79779C28.7123 4.71931 28.6308 4.64162 28.5485 4.56475C28.478 4.49914 28.407 4.43436 28.3355 4.37041C28.5602 4.57326 28.7794 4.78203 28.9929 4.99648ZM3.31514 16.9671C3.31514 9.42665 9.42774 3.31387 16.968 3.31387C20.5097 3.31387 23.7364 4.66252 26.1627 6.87427C26.271 6.97238 26.3777 7.07291 26.483 7.17581C29.0352 9.65661 30.6209 13.1267 30.6209 16.9671C30.6209 24.5076 24.5083 30.6204 16.968 30.6204C13.2245 30.6204 9.83282 29.1137 7.36638 26.6736C7.3338 26.6417 7.30134 26.6097 7.26905 26.5774C7.07144 26.3798 6.88244 26.1766 6.702 25.9682C4.59344 23.5652 3.31514 20.4154 3.31514 16.9671Z"
			fill="url(#paint5_linear_emblem)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.6455 6.29062C24.2455 2.89058 19.8718 1.04066 15.6217 0.886413C20.1876 0.121662 24.8613 1.26373 28.3355 4.37041C28.5602 4.57326 28.7794 4.78203 28.9929 4.99648C32.3629 8.41405 33.686 13.1481 33.0234 17.8109C32.7468 13.7207 30.9112 9.55644 27.6455 6.29062Z"
			fill="url(#paint6_linear_emblem)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_emblem"
				x1="32.2787"
				y1="6.1485"
				x2="1.65713"
				y2="25.4672"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.31" stopColor="#5172EA" />
				<stop offset="1" stopColor="#B9C8FF" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_emblem"
				x1="32.8758"
				y1="4.97702"
				x2="-0.586665"
				y2="25.4283"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#646464" />
				<stop offset="1" stopColor="#111111" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_emblem"
				x1="31.27"
				y1="6.1485"
				x2="1.07648"
				y2="24.6019"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B9C8FF" />
				<stop offset="1" stopColor="#5172EA" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_emblem"
				x1="32.2787"
				y1="6.1485"
				x2="1.65713"
				y2="25.4672"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.17" stopColor="#5172EA" />
				<stop offset="1" stopColor="#B9C8FF" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_emblem"
				x1="4.79207"
				y1="2.32076"
				x2="32.822"
				y2="29.4758"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B9C8FF" />
				<stop offset="1" stopColor="#5172EA" />
			</linearGradient>
			<linearGradient
				id="paint5_linear_emblem"
				x1="32.2786"
				y1="6.14797"
				x2="1.65707"
				y2="25.4667"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B9C8FF" />
				<stop offset="1" stopColor="#5172EA" />
			</linearGradient>
			<linearGradient
				id="paint6_linear_emblem"
				x1="32.2786"
				y1="6.14797"
				x2="1.65707"
				y2="25.4667"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#B9C8FF" />
				<stop offset="1" stopColor="#5172EA" />
			</linearGradient>
		</defs>
	</svg>
);

export default OnBibleEmblem;
